import Container from "@client/content/Containers/container";
import GoogleMaps, { type GoogleMapsOptions } from "@client/content/controls/GoogleMaps/component";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { getAssetUrl } from "@client/lib/assets";
import { MediaType } from "@client/types";
import * as React from "react";

import "./style.less";

export type MapsComponentProps = RootContainerProps & {
  googleKey: string;
  options: GoogleMapsOptions;
};

export default (props: MapsComponentProps) => {
  const style = React.useMemo(
    (): React.CSSProperties => ({
      backgroundImage: `url(${getAssetUrl("img/cm/maps/placeholder.jpg", MediaType.Image)})`
    }),
    []
  );

  return (
    <Container {...getContainerProps(props)}>
      <div className="wsc_content_maps" style={style}>
        <GoogleMaps googleKey={props.googleKey} options={props.options} />
      </div>
    </Container>
  );
};
